// Language codes enum
export enum LANGUAGE_CODES {
  ENGLISH = "en",
  HINDI = "hi",
}

// Collection name mappings for different languages
export const COLLECTION_NAMES = "ryze-gums";
